export const DEFAULT_ITEM_PAGE_OBJECT = {
  itemState: {
    id: 0,
    lotCode: '',
    auctionId: 0,
    currentBid: 0,
    quantity: 0,
    initialQuantity: 0,
    soldQuantity: 0,
    condition: '',
    description: '',
    msrp: 0,
    brand: '',
    specs: '',
    highBidder: 0,
    model: '',
    lotterId: '',
    loadNumber: '',
    title: '',
    nextBid: 0,
    itemClosed: false,
    itemTimeRemaining: '',
    hoursRemaining: 0,
    utcEndDateTime: '',
    removed: false,
    bidsCount: 0,
    pictures: [],
    pictureList: [],
    imageUrl: '',
    binEnabled: false,
    maoEnabled: false,
    bidsEnabled: false,
    auctionTypeId: 0,
    itemPaid: false,
    enableSMS: false,
    enableEmail: false,
    damageDescription: '',
    unitDescription: '',
    itemBidIncrementEnabled: false,
    itemIncrementMasterId: 0,
    palletLot: false,
    palletLotId: 0,
    overTime: false,
    removalReason: '',
    bidHistory: {
      values: [],
      visible: false,
    },
    weight: '',
    length: '',
    depth: '',
    width: '',
  },
  itemHandler: {},
  modal: {
    state: {
      showBidModal: false,
      showBanModal: false,
      showBinMaoModal: false,
      showViewModal: false,
      negativeZBid: false,
      negativeZBan: false,
      negativeZBinMao: false,
      negativeZView: false,
      modalAction: null,
      modalData: {},
      bins: [],
      binMade: false,
      offerMade: false,
      offers: [],
      showViewBtn: false,
      incrementModalVisible: false,
    },
    handlers: {},
    refs: {
      descriptionRef: {
        current: null,
      },
      titleRef: {
        current: null,
      },
      imagesRef: {
        current: null,
      },
    },
  },
  lastUpdated: '',
  infoSlideOutOpen: false,
  auction: {
    id: 0,
    auctionNumber: '',
    itemCount: 0,
    locationId: 0,
    utcStartDateTime: '',
    utcEndDateTime: '',
    picUrl: [],
    title: '',
    category: '',
    binEnabled: false,
    maoEnabled: false,
    bidsEnabled: false,
    status: '',
    pastAuction: false,
    isMnr: false,
    location: {
      id: 0,
      nickName: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      map: '',
      contactPhone: '',
      contactEmail: '',
      hours: '',
      taxRate: 0,
    },
    timeRemaining: '',
    endDateText: '',
    endTimeText: '',
    startDateText: '',
    startTimeText: '',
    premiumRate: 0,
    lastDayofAuction: false,
    featured: false,
    paidAuction: false,
    endTimeElapsed: false,
    notes: [],
    terms: [],
    auctionPickupDates: [],
    bidIncrements: [],
    numberOfItemsClosedEachMin: 0,
    auctionTypeId: 0,
  },
  setItemState: () => {},
  setInfoSlideOutOpen: () => {},
  pageNumber: 1,
}
